import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Table, TableColumnsType } from 'antd';
import {
  IActivityItem,
  ISemesterTimetable,
} from '../../../models/semesterProduct.model';
import Button from '../../Button';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  data: IActivityItem[];
  semesterTimetables: ISemesterTimetable[];

  onSetData(index: number, key: string, value: any): void;

  onDelete(value: number): void;

  onSubmit(record: IActivityItem): void;
}

const EvaluationTable: FC<IProps> = ({
  data,
  semesterTimetables,
  onSetData,
  onDelete,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const getMonthName = (monthSeq: number) => {
    const monthNameCode = semesterTimetables.find(
      (item: ISemesterTimetable) => item.monthSeq === monthSeq,
    )?.monthNameCode;
    return monthNameCode
      ? getCommonCodeLabel('SY0009', monthNameCode, 'ko')
      : null;
  };

  const getTimesOption = (monthSeq: number | null) => {
    const month = semesterTimetables.find(
      (item: ISemesterTimetable) => item.monthSeq === monthSeq,
    );
    if (month) {
      return month.timetableSeq.map((item: number, index: number) => (
        <Select.Option key={index} value={item}>
          {index + 1}
        </Select.Option>
      ));
    } else {
      return null;
    }
  };

  const columns: TableColumnsType<IActivityItem> = [
    {
      title: t('program.semester.column29'),
      key: 'curriculumName',
      dataIndex: 'curriculumName',
    },
    {
      title: t('program.semester.column22'),
      dataIndex: 'monthSeq',
      key: 'monthSeq',
      render: (value, record, index) => (
        <div className="w-50p">
          <Select
            className="w-100"
            placeholder={t('common.button.select')}
            value={value}
            onChange={(value) => onSetData(index, 'monthSeq', value)}
          >
            {semesterTimetables.map((item: ISemesterTimetable, index) => {
              return (
                <Select.Option key={index} value={item.monthSeq}>
                  {getMonthName(item.monthSeq)}
                </Select.Option>
              );
            })}
          </Select>
        </div>
      ),
    },
    {
      title: t('program.semester.column23'),
      dataIndex: 'timetableSeq',
      key: 'timetableSeq',
      render: (value, record, index) => (
        <div className="w-50p">
          <Select
            className="w-100"
            placeholder={t('common.button.select')}
            value={value}
            onChange={(value) => onSetData(index, 'timetableSeq', value)}
            disabled={!record.monthSeq}
          >
            {getTimesOption(record?.monthSeq || null)}
          </Select>
        </div>
      ),
    },
    {
      title: '',
      key: 'semesterSeqEvaluationCode',
      dataIndex: 'semesterSeqEvaluationCode',
      align: 'center',
      render: (value) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small gray"
            onClick={() => onDelete(value)}
            text={t('common.button.delete')}
            disabled={!value}
          />
        </div>
      ),
    },
    {
      title: '',
      key: 'timetableSeq',
      dataIndex: 'timetableSeq',
      align: 'center',
      render: (value, record) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small pink"
            onClick={() => onSubmit(record)}
            text={t('common.button.save')}
            disabled={!value}
          />
        </div>
      ),
    },
  ];

  return (
    <Table
      className='comm-table__area'
      columns={columns}
      dataSource={data}
      pagination={{ pageSize: 99999 }}
      rowKey="prdCurriculumCode"
      rowClassName={(record: any) => record.semesterSeqEvaluationCode ? '' : 'chosen'}      
    />
  );
};

export default EvaluationTable;
